<template>
  <div id="app">
    <custom-header />
    <router-view />
    <!--custom-footer />-->

    <spinner v-if="isLoading" />

    <transition name="slide">
      <toast
        v-if="toast"
        :success="toast.state === 1"
        :error="toast.state === 2"
        :danger="toast.state === 3"
      >{{toast.msg}}</toast>

      <!-- TODO: Fixa riktig timer och att den triggas rätt -->
    </transition>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner.vue'
import Toast from '@/components/Toast.vue'
import { mapGetters } from 'vuex'
import CustomHeader from '@/components/layout/Header'

export default {
  name: 'app',
  components: {
    Spinner,
    Toast,
    CustomHeader
  },
  computed: mapGetters(['isLoading', 'flags']),
  mounted () {
  },
  data () {
    return {
      toast: null
    }
  },
  created () {
    console.log('created')
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      let w = window.innerWidth
      let device = 'xs'
      if (w > 767) device = 'sm'
      if (w > 1023) device = 'md'
      if (w > 1199) device = 'lg'

      this.$store.commit('setDevice', device)
    }
  }
}
</script>

<style lang="less">
@import './styles/variables';
html {
  scroll-behavior: smooth;
}
html,
body {
  height: 100%;
}
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
#app {
  background: @color-grey-light;
  font-family: @font-family;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  overflow-x: hidden;
}
hr {
  border: none;
  border-top: 1px solid @color-grey-light;
  margin-bottom: 18px;
}

.card {
  position: relative;
  background: white;
  box-shadow: @shadow;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  padding: 20px 10px;
  width: 95%;
  margin: auto;
  bottom: 10px;
  transition: height 1s ease;
  max-width: 500px;

img  {
    max-width:100%;
max-height:100%;
  }
}
@media screen and (min-width: @sm-min-width) {
  .card {
  padding: 30px;
  }
}
header {
  margin-top: 18px;
    h1,
    h2,
    h3,
    h4 {
      margin-bottom: 5px;
    }
    margin-bottom: 35px;
    p {
      font-size: @font-size-small;
    }
  }

.content-wrapper {
  display: flex;
  flex:1;
  transition: height 1s ease;
  overflow-y: scroll;
  padding: 0 5%;
  width: 100%;
}

.container {
  background: @color-grey-light;
  background-image: linear-gradient(
      to bottom right,
      rgba(0, 0, 0, 0.65) 20%,
      rgba(0, 0, 0, 0.4) 100%
    ),
    url('https://firebasestorage.googleapis.com/v0/b/nordicperformancecenter-57600.appspot.com/o/website%2Fwebsite%2FNPCKiruna17.jpg?alt=media') !important;
  background-size: cover;
  flex: 1;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .again-button {
    border: none;
    background: @color-secondary;
    border: 2px solid rgba(255, 255, 255, 0.3);
    color: white;
    border-radius: @radius-small;
    box-shadow: @shadow;
    width: 300px;
    height: 100px;
    font-size: 32px;
    margin: 0 auto;
    cursor: pointer;
    svg {
      margin-right: 10px;
    }
  }
  nav {
    display: grid;
    grid-template-columns: calc(50% - 20px) calc(50% - 20px);
    grid-gap: 40px;
    width: 1200px;
    height: 800px;
    a {
      background-image: linear-gradient(
        to bottom right,
        white 40%,
        rgb(231, 231, 231)
      );
      font-size: 32px;
      box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
      white-space: nowrap;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: @radius-small;
      border-bottom: 8px solid;
      border-color: transparent;
      color: @color-grey-dark;
      svg {
        font-size: 100px;
        margin-bottom: 28px;
      }
    }
    a:hover {
      background: white;
      box-shadow: @shadow;
    }
    a:first-child {
      border-color: @color-secondary;
      svg {
        color: @color-secondary;
      }
    }
    a:nth-child(2) {
      border-color: @color-orange;
      svg {
        color: @color-orange;
      }
    }
    a:nth-child(3) {
      border-color: @color-green;
      svg {
        color: @color-green;
      }
    }
    a:last-child {
      border-color: @color-primary;
      svg {
        color: @color-primary;
      }
    }
  }

  footer {
    margin-top: 15px;
    font-style: italic;
    background-color: @color-grey-lightest;
    padding: 10px;
  }
  hgroup {
    background: @color-grey-lightest;
    padding: 20px 0 10px;
  }
  textarea {
    height: 200px;
    margin-bottom: 15px;
    resize: none;
  }
  .alt-link {
    color: @color-secondary;
  }
}
// Produkt väljare (Medlemskap OCH engångsträning)
.product-picker-page {
  .product-picker {
    display: flex;
    flex-direction: row;
    overflow-x: scroll;
    margin-bottom: 18px;
    .product-picker-item {
    user-select: none;
      transition: 0.2s ease all;
      display: flex;
      flex-direction: column;
      background: @color-grey-lightest;
      padding: 40px 20px;
    margin-bottom: 18px;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      min-width: 150px;
      max-height: 150px;
      flex: 1;
      font-size: @font-size-small;
      border: 3px solid transparent;
      position: relative;
      strong {
        margin-bottom: 5px;
      }
      .icon {
        background: white;
        position: absolute;
        color: @color-primary;
        margin-top: 60px;
        font-size: 48px;
      }
    }
    .product-picker-item:not(:last-child) {
      margin-right: 10px;
    }
    .product-picker-item:not(.active-product),
    .product-picker-item:not(.active-product) .icon {
      color: @color-grey-dark;
    }
    .active-product {
      background: white;
      box-shadow: @shadow;
      border-color: @color-primary;
      h5 {
        font-size: 28px;
      }
    }
    .active-product-blue {
      background: @color-primary;
      color: white;
    }
  }

  .more-info {
    transition: all 1s ease;
    margin-bottom: 20px;
    height: 150px;
    padding: 20px;
    border: 1px solid @color-grey-medium;
    overflow-y: scroll;
    box-shadow: inset @shadow;
  }
  .hide-more-info {
    height: 0px;
    padding: 0;
    border: none;
  }
  .more-info-button {
    display: flex;
    align-items: center;
    background: @color-grey-lightest;
    box-shadow: @shadow;
    color: @color-primary-dark;
    border: none;
    font-weight: bold;
    padding: 9px 14px;
    font-size: 16px;
    align-self: center;
    margin: 20px 0;
    i {
      margin-left: 5px;
    }
  }
  .more-info-button:focus {
    outline: none;
  }
  .more-info-button:active {
    box-shadow: none;
  }
}
  @media screen and (min-width: @sm-min-width) {
    .product-picker-page {
      max-width: 750px;
      .product-picker {
        width: 100%;
        overflow: hidden;
        .product-picker-item {
          flex:1;
        }
      }
    }
  }
/*
   animation
*/
.slide-enter-active,
.slide-leave-active {
  transition: all 0.8s;
  opacity: 1;
}

/*
   before transition start
*/
.slide-enter,
.slide-leave-to {
  margin-top: -50px;
  opacity: 0;
}

/*
   at end transition
*/
.slide-enter-to,
.slide-leave {
  margin-top: 0px;
}
</style>
